/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2018, Zumper
 * @description
 */

import type {
  Listable,
  MaybeEmptyProperty,
  Pin,
  RawPinInventorySearch,
  State,
} from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import { getEntityProperties } from './getEntityProperties'

/**
 * Gets the event properties for "detail" event i.e. events emitted from detail page
 *
 * @param entity
 * @param isBubble
 */
export const getDetailEventProperties = (
  entity: MaybeEmpty<Listable> | MaybeEmptyProperty | Pin<RawPinInventorySearch>,
  state: State,
  isBubble?: boolean
) => {
  return {
    ...getEntityProperties(entity, state),
    amenities: entity.amenities,
    buildingAmenities: entity.buildingAmenities,
    isBubble,
  }
}
